import {Observable} from 'rxjs';
import {Injectable, NgZone} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {EventSourcePolyfill} from 'node_modules/event-source-polyfill/src/eventsource.min.js';

@Injectable({
  providedIn: 'root',
})

/*
 * Service to import files
 *
 */
export class EventService {
  constructor(private authService: AuthService) {
  }

  getServerSentEvent(url: string): Observable<any> {
    return Observable.create(observer => {
      const eventSource = this.getEventSource(url);
      eventSource.addEventListener('url', (e) => {
        // console.log(e);
        observer.next(e);
        eventSource.close();
      });
      eventSource.addEventListener('id', (e) => {
        // console.log(e);
        observer.next(e);
        eventSource.close();
      });
      eventSource.addEventListener('loading', (e) => {
        // console.log(e);
        observer.next(e);
      });
      eventSource.addEventListener('connecting', (e) => {
        // console.log(e);
        observer.next(e);
      });
      eventSource.addEventListener('error', (e) => {
        // console.log(e);
        observer.next(e);
        eventSource.close();
      });
      return () => eventSource.close();
    });
  }

  private getEventSource(url: string): EventSource {
    return new EventSourcePolyfill(url, {
      headers: {
        Authorization: `Bearer ${this.authService.getAccessToken()}`
      }
    });
  }
}
